import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MaterialLink from '../material-link';

const CalendarFooter = () => {
  return (
    <Box sx={{ mt: 3, textAlign: 'center' }}>
      <Typography variant="body2" color="text.primary">
        Anyone can <MaterialLink href="/events/new">add an event</MaterialLink> to
        the calendar. You can also <MaterialLink href="/calendar/subscribe">subscribe</MaterialLink> to
        get updates.
        <br />
        <MaterialLink href="/about">Learn more</MaterialLink> about who posts these events.
      </Typography>
    </Box>
  );
};

export default CalendarFooter;
